import '@site/styles/sass/styles.scss';

import './vendor/element-closest';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import './module/carousel';
import './module/accordion';
// import './module/modal';
import './module/scroll';
// import './module/embed-gallery';
// import './module/cookies';
// import './module/form';

async function setvh() {
    const vh = await window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
};
setvh();

/* navigation header */
import Menubar from './module/menubar/MenubarLinks';
const mtMenuBar = new Menubar(document.getElementById('top-nav-menubar'));
if (mtMenuBar) {
    mtMenuBar.init();
}
const mainMenuBar = new Menubar(document.getElementById('nav-menubar'));
if (mainMenuBar) {
    mainMenuBar.init();
}

import AutoComplete from './module/autocomplete/autocomplete';
const headerSearchEl = document.querySelector('#headerSearch');
const headerSearch = new AutoComplete(headerSearchEl);
if (headerSearch) {
    headerSearch.init();
}

let previousScrollY = 0;
const bodyElement = document.querySelector('body');
function classToggle(toggleElement, className) {
    toggleElement.classList.toggle(className);
}

document.querySelector('.menu-toggle').addEventListener('click', function() {
    classToggle(bodyElement, 'menuopen');

    if (bodyElement.classList.contains('menuopen')) {
        this.querySelector('.menu-text').innerHTML = 'Close';
        previousScrollY = window.scrollY;
        bodyElement.style.position = 'fixed';

        mtMenuBar.setPreviousScrollY(previousScrollY);
        mainMenuBar.setPreviousScrollY(previousScrollY);
    } else {
        mtMenuBar.closePopmenu();
        mainMenuBar.closePopmenu();

        this.querySelector('.menu-text').innerHTML = 'Menu';
        bodyElement.style.position = 'initial';
        window.scrollTo(0, previousScrollY);
    }

    if (bodyElement.classList.contains('searchopen')) {
        headerSearch.closeMobileSearchPopup();
    }
});

/* window resize */
const mediaBreakPoint = '(max-width: 1024px)';
const mq = window.matchMedia(mediaBreakPoint);

window.addEventListener('resize', function() {
    // var vh = window.innerHeight * 0.01;
    // document.documentElement.style.setProperty('--vh', vh + 'px');

    if (!mq.matches && bodyElement.classList.contains('menuopen')) {
        mtMenuBar.close();
        mainMenuBar.close();
        mtMenuBar.closePopmenu();
        mainMenuBar.closePopmenu();
    } else if (mq.matches && !bodyElement.classList.contains('menuopen')) {
        mtMenuBar.closePopmenu();
        mainMenuBar.closePopmenu();
    }

    if (!mq.matches && bodyElement.classList.contains('searchopen')) {
        headerSearch.closeMobileSearchPopup();
    }
});

const printBtn = document.querySelector('.js-print');
if (printBtn) {
    printBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.print();
    });
}

const fileDownloads = document.querySelectorAll('.js-download');
for (let btn of fileDownloads) {
    btn.addEventListener('click', function (eve) {
        var url = this.getAttribute('data-href');
        var fileName = this.getAttribute('download');
        var xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.responseType = 'blob';

        xhr.onload = function () {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
            link.innerText = 'Download Image';
        };

        xhr.send();
    });
}

/* added _blank for all external links */
const allLinks = document.querySelectorAll('[href^=http]');
for(let linkElem of allLinks) {
    if(linkElem.href.indexOf(window.location.hostname) < 0) {
        linkElem.setAttribute('target', '_blank');
    }
}

/* home page scrolldown buttons */
const scrolldownBtns = document.querySelectorAll('.js-home-scrolldown');
for(let btnElem of scrolldownBtns) {
    btnElem.addEventListener('click', function(eve) {
        eve.preventDefault();
        eve.stopPropagation();
        const homeBannerEl = btnElem.closest('.banner-type-one');
        const nextEl = homeBannerEl.nextElementSibling;
        scroll(0, nextEl.offsetTop, { behavior: 'smooth' });
    });
}

// swtich languages
// document.querySelector("[data-lang-type='en|en']").classList.add('active');
// const langSwitchers = document.querySelectorAll('.js-country-link');

// if (langSwitchers.length) {
//     for (let btnElem of langSwitchers) {
//         btnElem.addEventListener('click', function(eve) {
//             eve.preventDefault();
//             eve.stopPropagation();

//             for (let elem of langSwitchers) {
//                 elem.classList.remove('active');
//             };

//             eve.currentTarget.classList.add("active");
//             const langType = eve.currentTarget.getAttribute('data-lang-type') || 'en|en';
//             window.doGTranslate(langType);
//             return false;
//         });
//     }
// }

const observer = new MutationObserver(mutationCallback);
observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: false,
    characterData: false
})

function mutationCallback() {
    if(document.documentElement.className.match('translated')) {
        if (document.documentElement.lang === 'cy') {
            for (let elem of langSwitchers) {
                elem.classList.remove('active');
            };
            document.querySelector("[data-lang-type='en|cy']").classList.add('active');
        }
        observer.disconnect();
    }
}

const copyLink = document.querySelector('.js-copy-link');
if (copyLink) {
    copyLink.addEventListener('click', function (e) {
        e.preventDefault();
        const cb = navigator.clipboard;
        cb.writeText(window.location.href).then(() => alert('Link copied'));
    });
}

const allQuicklinks = document.querySelectorAll('.content-block-layout');
const allServicesLinks = [];
const serviceLinksContainerEl = document.querySelector('#quicklinksContainer');
const headerOffset = 170;
for(let quicklinksElem of allQuicklinks) {
    if (quicklinksElem.getAttribute('id') && quicklinksElem.getAttribute('data-title')) {
        allServicesLinks.push({
            id: quicklinksElem.getAttribute('id'),
            title: quicklinksElem.getAttribute('data-title')
        });
    }
}
if (serviceLinksContainerEl && allServicesLinks.length > 0) {
    serviceLinksContainerEl.innerHTML = '';

    for(let serviceItem of allServicesLinks) {
        const serviceLinkEl = document.createElement('a');
        serviceLinkEl.classList.add('button', 'plain');
        serviceLinkEl.href = document.URL + '#' + serviceItem.id;
        serviceLinkEl.title = serviceItem.title;
        serviceLinkEl.innerHTML = serviceItem.title;
        serviceLinkEl.setAttribute('data-target', serviceItem.id);
        serviceLinkEl.addEventListener('click', function(eve) {
            eve.preventDefault();
            eve.stopPropagation();
            console.log(eve.target.getAttribute('data-target'));
            const targetEl = document.querySelector(`#${eve.target.getAttribute('data-target')}`);
            const elementPosition = targetEl.offsetTop;
            const offsetPosition = elementPosition - headerOffset;

            scroll(0, offsetPosition, { behavior: 'smooth' });
        });

        serviceLinksContainerEl.appendChild(serviceLinkEl);
    }
}